import React, { useEffect, useRef, useState } from "react";
import JoditEditor from "jodit-react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Container, Row, Col } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import * as termsSlice from "../../../../redux/slices/termSlice"; // Replace with actual slice for Terms and Conditions

const PrivacyPolicy = () => {
  const [content, setContent] = useState("");
  const editor = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const { privacyPageDetails, loading } = useSelector(
    (state) => state.termSlice
  );

  useEffect(() => {
    dispatch(termsSlice.getPrivacyPageDetails()); // Fetch terms by ID
  }, []);


  useEffect(() => {
    if (privacyPageDetails) {
      setContent(privacyPageDetails?.content || ""); // Load existing terms content
    }
  }, [privacyPageDetails]);

  const config = {
    placeholder: "Type privacy and policy here...",
    readonly: false,
    toolbar: true,
    uploader: {
      insertImageAsBase64URI: false,
    },
  };

  const handleSave = async () => {
    await dispatch(
      termsSlice.createPrivacyPolicy({
        content,
      })
    );
    dispatch(termsSlice.getPrivacyPageDetails());
  };

  return (
    <Container>
      <Row className="mt-4">
        <Col>
          <Button
            style={{ backgroundColor: "#e8783d", border: "none" }}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
          <h1 className="text-center mt-3">Privacy and Policy</h1>
        </Col>
      </Row>
      {false ? (
        <div className="d-flex justify-content-center mt-5">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      ) : (
        <Row className="mt-4">
          <Col>
            <JoditEditor
              ref={editor}
              value={content}
              onBlur={(newContent) => setContent(newContent)}
              config={config}
            />

            <div className="d-grid gap-2 mt-3">
              <Button variant="success" size="lg" onClick={handleSave}>
                Save
              </Button>
            </div>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default PrivacyPolicy;
